import React from "react";
import axios from "axios";
import ReportsError from './ReportsError';
import ReportsTotals from './ReportsTotals';
import { 
    getFromLocalStorage,

} from './Utilities';

class ReportsTopActivities extends React.Component {
    constructor(props) {
        super(props);

        var filters = getFromLocalStorage("report_data");
        if (filters.constructor.name === "String") {
            filters = JSON.parse(filters);
        }

        const brandIDs = this.getBrandIDs(filters?.ChooseBrands);
        var endpoint = "brand/stats/activity";
        if(brandIDs && brandIDs.length > 0){
            endpoint += "&brandids="+brandIDs;
        }
        var url = "react/process?endpoint=" + endpoint + "&hourly_cutoff=0&turnoffdebug=1&includeonetime=1&limit=10";
        if(filters.ChooseActivities && filters.ChooseActivities.Segment) url += "&segmentid="+filters.ChooseActivities.Segment.ID;

        this.state = {
            isLoading: true,
            url: url,
            activities: {},
            error: null
        };
    }


    componentDidMount() {
        this.getData();
    }

    // Function to fetch data from the server
    getData() {
        if(this.state.url) axios.get(this.state.url).then(response => this.formatData(response));
    }

    // Function to format the fetched data
    formatData(response) {
        const data = response.data; // Axios response wrapper
        let activities = [];
        let error = null;

        if (data?.items) {
            activities = data.items;
        } else if (data?.error) {
            error = data.error;
        }

        //console.log(activities); // this will now correctly show activities
        this.setState({ activities, error: error?.message || null, isLoading: false });
    }

    getBrandIDs(brandData){
         var brands = {};
         if(brandData){
             brands = Object.values(brandData).map(function(obj, key){//sometimes first key is null, get valid brands
                if(typeof obj != "undefined") return obj.ID;
             });
         }
         if(Object.keys(brands).length > 1) return brands.join(",");
         return brands;   
    }

    render() {
        const { activities, isLoading, error } = this.state;

        if (isLoading) {
            return (
                <div className="loading">
                    Loading...
                </div>
            );
        }

        if (error) {
            return (
                <div className="error">
                    {error}
                </div>
            );
        }

        return (
            <div className="feed-topactivities">
                <table id="basic-datatable" className="table dt-responsive nowrap w-100">
                    <thead>
                        <tr>
                            <th>Channel</th>
                            <th>Activity</th>
                            <th>Frequency</th>
                        </tr>
                    </thead>
                    <tbody>
                        {activities.map((activity, idx) => (
                            <tr key={`${activity.ActivityID}-${activity.BrandID}-${idx}`}>
                                <td>{activity.ServiceType}</td>
                                <td>{activity.Activity}</td>
                                <td>{activity.Count}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

}

export default ReportsTopActivities;
